var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("account-plan-message-modal", {
    ref: "modal",
    attrs: { id: "cancel-plan-confirmation-modal" },
    on: {
      hide: function ($event) {
        _vm.computedShown = false
      },
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [_vm._v("\n    " + _vm._s(_vm.titleText) + "\n  ")]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("i18n", {
              staticClass: "text-gray",
              attrs: { path: _vm.bodyText, tag: "p" },
              scopedSlots: _vm._u([
                {
                  key: "agents",
                  fn: function () {
                    return [
                      _c("span", { staticClass: "bold" }, [
                        _vm._v(
                          "\n          " + _vm._s(_vm.agentsText) + "\n        "
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "expirationDate",
                  fn: function () {
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.formattedAccountExpiration) +
                          "\n      "
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("account-plan-perks", {
              attrs: { plan: _vm.freeAccountPlan, perks: false },
            }),
            _vm._v(" "),
            _vm.isCurrentSubscription
              ? _c("i18n", {
                  staticClass: "text-danger mb-0 mt-2",
                  attrs: {
                    path: "account.accountPlan.planModals.cancelConfirmation.cancelAllSubscriptionsWarning",
                    tag: "p",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "subscriptionsLink",
                        fn: function () {
                          return [
                            _c(
                              "router-link",
                              {
                                staticClass: "text-primary clickable",
                                attrs: {
                                  to: {
                                    name: "account-plan-tab",
                                    params: {
                                      internal: true,
                                      tab: "subscriptions",
                                    },
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.$t(
                                        "account.accountPlan.subscriptionsTab.title"
                                      )
                                    ) +
                                    "\n          "
                                ),
                                _c("icon", {
                                  attrs: { name: "external-link" },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    475140299
                  ),
                })
              : _vm._e(),
            _vm._v(" "),
            _c("p", { staticClass: "text-gray mt-2" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t(
                      "account.accountPlan.planModals.cancelConfirmation.bodyTextEnd"
                    )
                  ) +
                  "\n    "
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "simple-button",
              {
                attrs: { type: "danger", loading: _vm.loading },
                on: {
                  click: function ($event) {
                    return _vm.$emit("cancel-plan")
                  },
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("account.accountPlan.cancelSubscription")) +
                    "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }